const codeToConstantDictionary: Record<string, string | undefined> = {
  identityMismatch:
    'The Google account you signed in with does not match this invitation. Please sign in with the correct account.',
  rosterNotMatched:
    "We couldn't match your Google account to your school's student records. Please contact your school counselor.",
  accountNotFound:
    'No Scoir account was found for this Google account. Please sign in with the account associated with your invitation.',
  schoolUnresolved:
    "We're unable to connect you to your school at this time. Please contact your school counselor to be invited.",
}

const InviteErrorConstants = (errorCode?: string) => {
  if (!errorCode) return null
  const lookup = codeToConstantDictionary[errorCode]
  return lookup || null
}

export default InviteErrorConstants
